import AjaxUtil from '../../axios/axios';

/**
 * get ai modules list 
 */
export const getAiModules = async() => {    
    try {
        return await AjaxUtil.sendRequest(`/getuser/aisubscription`, {}, false, { method: 'get', showError:true, isProfile:false});
    } catch (error) {
        throw error;
    }
 }
